import React, { useContext } from 'react';
import CaptchaContext from 'common/Form/FormWithCaptcha/CaptchaContext';

const useFormCaptcha = () => {
  const state = useContext(CaptchaContext);

  if (!state) {
    return {
      isRequired: false,
    };
  }

  return state;
};

export default useFormCaptcha;
